(function($, Drupal, drupalSettings) {

  Drupal.behaviors.mba_data_001 = {
    attach: function (context, settings) {

      // Map out mbf_bg_color tax term titles to hex codes. //
      var colours = {
        'bg-black': '#000000',
        'bg-blue': '#3366ff',
        'bg-blue-dark': '#0032e6',
        'bg-graphite': '#6f7779',
        'bg-green': '#63ba68',
        'bg-green-dark': '#3a8340',
        'bg-grey': '#deedf2',
        'bg-grey-10': '#fbfdfd',
        'bg-grey-50': '#eef6f8',
        'bg-grey-dark': '#9bc3d3',
        'bg-grey-medium': '#c3dee7',
        'bg-purple': '#9e3667',
        'bg-purple-10': '#f5eaef',
        'bg-purple-20': '#ebd6e0',
        'bg-purple-50': '#ce9ab3',
        'bg-purple-dark': '#732645', 
        'bg-red': '#ec0000', 
        'bg-red-10': '#fde5e5',
        'bg-red-20': '#fbcccc',
        'bg-red-50': '#f57f7f',
        'bg-red-dark': '#990000',
        'bg-red-hover': '#b30000', 
        'bg-red-medium': '#cc0000',
        'bg-turquoise': '#1bb3bc',
        'bg-turquoise-10': '#e8f7f8',
        'bg-turquoise-20': '#d1f0f2',
        'bg-turquoise-50': '#8dd9dd',
        'bg-turquoise-dark': '#137e84',
        'bg-white': '#ffffff',
        'bg-yellow': '#ffcc33',
        'bg-yellow-10': 'fff9ea',
        'bg-yellow-20': '#fff4d6',
        'bg-yellow-50': '#ffe599',
        'bg-yellow-dark': '#946f00',
      };

      var element = $('.mba-data-001');

      if (element.length) {
        element.mba_data_001({
            colours: colours,
        });
      }

    }
  }; // Drupal.behaviors.mba_data_001

})(jQuery, Drupal, drupalSettings);
